import { render, staticRenderFns } from "./ProductReceipts.vue?vue&type=template&id=20560e01&"
import script from "./ProductReceipts.vue?vue&type=script&lang=js&"
export * from "./ProductReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports